import React from 'react';
import { Languages } from 'lucide-react';
import { useLang } from '../lib/i18n';

// Small EN/ES switch. Shows the language you can switch TO.
export default function LanguageToggle({ className = '' }) {
  const { lang, setLang } = useLang();
  return (
    <button
      type="button"
      onClick={() => setLang(lang === 'es' ? 'en' : 'es')}
      className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 px-3 py-1.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition ${className}`}
      data-testid="lang-toggle"
      aria-label="Toggle language"
    >
      <Languages className="w-4 h-4" />
      {lang === 'es' ? 'English' : 'Español'}
    </button>
  );
}
